import React, { useState } from 'react';
import { Mail, Lock, User, Github, Eye, EyeOff } from 'lucide-react';
import { Link } from 'react-router-dom'
import { useToaster } from '../Context/ToasterContext'
import api from '../api'
import { IoCalendarNumber } from 'react-icons/io5'
import {useNavigate} from 'react-router-dom'
import { GoNumber } from 'react-icons/go'
import { useAuth } from '../Context/AuthContext'
import Navbar from './../Components/NavBar/NavBar'
import Footer from "./../Components/LandingPage/Footer"
import Bg from '../Components/background/Bg'

const SignupPage = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [credentials, setCredentials] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        otp: ""
    });
    const {auth, setAuth} = useAuth();
    const [otpFlag, setOtpFlag] = useState(false);
    const {addToaster, removeToaster} = useToaster()
    const navigate = useNavigate();
    
    const handleChange = (e) => {
        setCredentials((prevState) => {
            return {
                ...prevState,
                [e.target.name]: e.target.value,
            }
        })
    }
    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if(credentials.password !== credentials.confirmPassword) {
            addToaster("Passwords do not match!", 400)
            setTimeout(() => {
                removeToaster();
            },3000)
            return
        }
        if(!otpFlag) {
            addToaster("Creating Account", 100)
            api.post("/auth/signup",{
                email: credentials.email,
                password: credentials.password,
                name: credentials.name,
            }).then((res) => {
                const response = res.data;
                addToaster(response.message, response.statusCode)
                if(response.statusCode === 200){
                    setOtpFlag(true)
                }
            }).finally(() => {
                setTimeout(() => {
                    removeToaster();
                },3000)
                
            })
            return
        }
        
        addToaster("Verifying Otp", 100);
        api.post("/auth/otp-verify",{
            email: credentials.email,
            otp: credentials.otp,
        }).then((res) => {
            const response = res.data;
            addToaster(response.message, response.statusCode)
            if(response.statusCode === 200){
                setTimeout(()=>{
                    setAuth({
                        id: response.id,
                        role: response.role,
                    })
                    
                    sessionStorage.setItem("accessToken",response.jwtToken);
                    navigate("/dashboard")
                }, 1000)
            }
        }).finally(() => {
            setTimeout(() => {
                removeToaster();
            },3000)
        })
        
    }
    
    return (
        <div className="min-h-screen bg-base-200 flex flex-col items-center justify-center p-4 relative">
            <Navbar page="signupPage"/>
            <Bg />
            <div className="w-full max-w-md lg:max-w-lg bg-base-100 rounded-2xl shadow-xl p-8 absolute z-[10] border border-neutral">
                
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-primary">Create Account</h1>
                    <p className="text-base-content/70 mt-2">{!otpFlag ? "Singup to get started" : "Verify Otp" }</p>
                </div>
                
                
                <form className="space-y-5" onSubmit={handleSubmit}>
                    {
                        !otpFlag &&
                        <>
                            <div>
                                <label className="block text-sm font-medium text-base-content mb-2">
                                    Full Name
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <User size={18} className="text-base-content/50" />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Enter Your Name"
                                        className="w-full py-3 pl-10 pr-4 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                        required
                                        name="name"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-base-content mb-2">
                                    Email Address
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Mail size={18} className="text-base-content/50" />
                                    </div>
                                    <input
                                        type="email"
                                        placeholder="you@example.com"
                                        className="w-full py-3 pl-10 pr-4 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                        required
                                        name="email"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-base-content mb-2">
                                    Password
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Lock size={18} className="text-base-content/50" />
                                    </div>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="••••••••"
                                        className="w-full py-3 pl-10 pr-12 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                        required
                                        onChange={handleChange}
                                        name="password"
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={togglePasswordVisibility}
                                        tabIndex="-1"
                                    >
                                        {showPassword ? (
                                            <EyeOff size={18} className="text-base-content/70 hover:text-base-content" />
                                        ) : (
                                            <Eye size={18} className="text-base-content/70 hover:text-base-content" />
                                        )}
                                    </button>
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-base-content mb-2">
                                    Confirm Password
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Lock size={18} className="text-base-content/50" />
                                    </div>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder="••••••••"
                                        className="w-full py-3 pl-10 pr-12 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                        required
                                        onChange={handleChange}
                                        name="confirmPassword"
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={toggleConfirmPasswordVisibility}
                                        tabIndex="-1"
                                    >
                                        {showConfirmPassword ? (
                                            <EyeOff size={18} className="text-base-content/70 hover:text-base-content" />
                                        ) : (
                                            <Eye size={18} className="text-base-content/70 hover:text-base-content" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </>
                    }
                    {
                        otpFlag &&
                        <>
                            <div>
                                <label className="block text-sm font-medium text-base-content mb-2">
                                    Enter Otp
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <GoNumber size={18} className="text-base-content/50" />
                                    </div>
                                    <input
                                        type="number"
                                        placeholder="Otp has been send to Email"
                                        className="w-full py-3 pl-10 pr-4 bg-base-200 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                                        required
                                        name="otp"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </>
                    }
                    
                    <div>
                        <button
                            type="submit"
                            className="w-full bg-primary hover:bg-primary-focus text-primary-content py-3 rounded-lg font-medium transition-colors duration-300"
                        >
                            {!otpFlag ?  "Create Account" : "Verify Otp"}
                        </button>
                    </div>
                </form>
                
                
                
                
                {
                    !otpFlag &&
                    <>
                        <div className="flex items-center my-6">
                            <div className="flex-grow border-t border-base-300"></div>
                            <span className="px-4 text-sm text-base-content/60">OR SIGN UP WITH</span>
                            <div className="flex-grow border-t border-base-300"></div>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <button className="flex items-center justify-center gap-2 bg-base-100 hover:bg-base-200 text-base-content py-3 px-4 rounded-lg border border-base-300 transition-colors duration-300">
                                <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                                </svg>
                                <a className="font-medium" href={process.env.REACT_APP_GOOGLE_API_ENDPOINT}>Google</a>
                            </button>
                            
                            <button className="flex items-center justify-center gap-2 bg-base-100 hover:bg-base-200 text-base-content py-3 px-4 rounded-lg border border-base-300 transition-colors duration-300">
                                <Github size={20} />
                                <a className="font-medium" href={process.env.REACT_APP_GITHUB_API_ENDPOINT}>GitHub</a>
                            
                            </button>
                        </div>
                    </>
                }
                
                
                {
                    !otpFlag &&
                    <div className="text-center mt-8">
                        <p className="text-base-content">
                            Already have an account?
                            <Link to="/login" className="text-primary hover:text-primary-focus font-medium ml-1">
                                Sign in
                            </Link>
                        </p>
                    </div>
                }
                
            </div>
            {/*<Footer />*/}
        </div>
    );
};

export default SignupPage;